module.exports = __webpack_public_path__ + "media/images/photos/photo-8-f101397ffc2fa96ad72fef6ba68b7d15.jpg";